<template>
    <div @touchmove.prevent="noScroll" :class="[loginShow ? 'come-login' : '', 'login-detail']">

        <div class="container">

            <div class="content">

                <div class="login">

                    <ul class="cloud-items">

                        <li class="m-list dashboard item" v-if="isStorageAvailableCountry || isOtherRegion">
                            <router-link class="link" :to="{name: 'cloud-plan'}">
                                {{$t('header.cloud_plan')}}
                                <i class="icon icon-icon_arrow-right"/>
                            </router-link>
                        </li>

                        <li class="m-list library item" v-if="isDataAvailableCountry || isOtherRegion">
                            <router-link class="link" :to="{name: 'sim-plan-list'}">
                                {{$t('header.sim_card')}}
                                <i  class="icon icon-icon_arrow-right"/>
                            </router-link>
                        </li>
                        <li class="m-list item" @click="showItems.cloudManagement = !showItems.cloudManagement">
                            <div class="link" >
                                {{$t('header.management')}}
                                <fade  mode="out-in" :time="0.15">
                                    <i :key="showItems.cloudManagement?'up': 'down'" :class="showItems.cloudManagement?'icon-icon_arrow-up': 'icon-icon_arrow-down'"/>
                                </fade>
                            </div>
                        </li>
                        <fade group>
                            <template v-if="showItems.cloudManagement">
                                <li class="m-list management item" v-for="nav in navList" :key="nav.path">
                                    <router-link class="link" :to="nav.path">
                                        {{$t(nav.label)}}
                                        <i class="icon icon-icon_arrow-right"/>
                                    </router-link>
                                </li>
                            </template>
                        </fade>

                    </ul>
                </div>
                <country-selector />

            </div>

        </div>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import { headerHandle } from '@/common/js/header';
import { getNavList, INavItem } from '../lib/utils';
import Fade from '@/basic/transitions/Fade.vue';
import CountrySelector from './CountrySelector.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'LoginDetail',
    components: {
        Fade,
        CountrySelector
    },
    props: {
        loginId: {
            type: Number,
            default: 0
        },

        loginAvatarurl: {
            type: String,
            default: ''
        },

        loginShow: {
            type: Boolean,
            default: false
        }
    },

    data () {

        return {
            config,
            langList: config.langList,
            showItems: {

                langShow: false,
                settingsShow: false,
                cloudManagement: false

            },

        };

    },

    computed: {
        ...mapGetters( [
            'isStorageAvailableCountry',
            'isDataAvailableCountry',
            'isOtherRegion'
        ] as const ),
        isLogin (): boolean {

            return !!this.loginId;

        },

        profileUrl (): string {

            return config.accountCenterProfileUrl;

        },

        accountSecurityUrl (): string {

            return config.accountCenterSecurityUrl;

        },

        langRes (): string {

            let lang = this.$store.state.lang.lang;
            return this.$t( `lang.mobile.${lang}` ) as string;

        },
        
        navList(): INavItem[] {

            return Object.values( getNavList( this.$i18n ));
        
        }

    },

    methods: {

        emitEvent ( name ) {

            this.$emit( name );

        },

        noScroll () {

            return false;

        },

        selectLang ( lang ) {

            this.$store.commit( 'SELECT_LANG', lang );
            this.showItems.langShow = false;
            this.$i18n.locale = lang;
            headerHandle( this.$route );
            window.location.reload();

        },

        changeShowItems ( item ) {

            let currentItem = !this.showItems[item];

            for ( let key in this.showItems ) {

                this.showItems[key] = false;

            }

            this.showItems[item] = currentItem;

        }

    }

});
</script>

<style scoped rel="stylesheet/css" lang="less">

    .login-detail {
        position: fixed;
        z-index: -1;
        top: 50px;
        left: 0;
        bottom: 0;
        right: 0;
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
        transition: all 0.3s ease;
        -webkit-transition: all 0.3s ease;
        height: calc(100vh - 50px);
        height: calc(100dvh - 50px);
    }

    .login-detail.come-login {
        transform: translateX(0);
        -webkit-transform: translateX(0);
    }

    .login-detail .list-come .m-list,
    .login-detail .list-come.m-list,
    .login-detail .list-come.lang {
        background-color: #fff;
    }

    .login-detail .list-wrap {
        padding: 0 0.3rem;
    }

    .login-detail .mask {
        position: absolute;
        z-index: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
    }

    .login-detail .close {
        position: absolute;
        top: 0.28rem;
        right: 0.28rem;
    }

    .login-detail .close span {
        font-size: 0.4rem;
        color: #fff;
    }

    .login-detail .container {
        height: 100%;
        width: 100%;
        background-color: #fff;
        position: relative;
        padding: 18px 0 24px;
        box-sizing: border-box;
    }

    .login-detail .lang {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0 0.3rem;
        box-sizing: border-box;
    }

    .login-detail .list-wrap .m-list {
        font-size: 0.26rem;
        padding: 0.3rem 0;
    }

    .m-list {
        width: 100%;
        padding: 0.2rem 0;
        text-align: left;
        font-size: 0.32rem;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
    }

    .m-list a {
        width: 100%;
        box-sizing: border-box;
        color: #333;
        position: relative;
    }

    .login-detail .content {
        position: relative;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .login-detail .content .menu-bg-wrap {
        position: relative;
        left: 0;
        bottom: 0;
    }
    .login-detail .content .menu-bg-wrap img {
        max-height: 100%;
        max-width: 100%;
    }

    .login-detail .no-login {
        color: @theme;
        font-weight: 500;
        font-size: 0.32rem;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        text-align: center;
        transform: translate(-50%,-50%);
    }

    .login-detail .no-login .line {
        font-weight: 400;
    }

    .login-detail .no-login a {
        cursor: pointer;
    }

    .login-detail .login .user-info-wrap {
        height: 2rem;
        width: 100%;
        position: relative;
        padding: 0 0.3rem;
        background-color: #f7f8f9;
        box-sizing: border-box;
    }

    .login-detail .login .user-info {
        position: absolute;
        top: 50%;
        left: 0.3rem;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        text-align: left;
    }

    .login-detail .login .user-info .user-avatar {
        width: 1.22rem;
        height: 1.22rem;
        border-radius: 100%;
        border: 1px solid #f1f1f1;
    }

    .login-detail .login .user-info .log-out {
        color: @theme;
        font-weight: 500;
        font-size: 0.32rem;
        margin-left: 0.4rem;
        cursor: pointer;
    }

    .login-detail .login .cloud-items .item {
        padding: 12px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.management{
            padding-left: 48px;
            transition: all .3s ease;
        }
    }
    
    .link{
        font-size: 16px;
        line-height: 24px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        i{
            font-size: 12px;
        }
    }

    @media screen and (max-width: 800px) {

        .login-detail .content {
            background-size: 4rem auto;
        }

    }

    @media screen and (max-width: 750px) {

        .login-detail .login .user-info-wrap {
            height: 4rem;
        }

        .m-list {
            padding: 0.3rem 0;
        }

    }
</style>
